import React, { useState } from 'react';
import {Accordion, AccordionDetails, AccordionSummary, makeStyles, Typography} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {t} from "../common/LocalizationProvider";
import LinkField from "../form/LinkField";
import {prefixString} from "../common/stringUtils";
import EditItemView from "../shared/EditItemView";
import {cyberStyles} from "../cssShared/cyberTheme";


const useStyles = makeStyles((theme) => ({
    ...cyberStyles(theme),
}));

const DeviceConnections = () => {
    const classes = useStyles();

    const [item, setItem] = useState();

    return (
        <EditItemView endpoint="devices" item={item} setItem={setItem}>
            {item?.id &&
                <Accordion defaultExpanded className={classes.accordion}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon style={{ color: '#00f2ff' }} />}>
                        <Typography className={classes.summaryText}>
                            {t('sharedConnections')}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={`${classes.details} ${classes.linkFieldWrapper}`}>
                        <LinkField
                            margin="normal"
                            endpointAll="/api/geofences"
                            endpointLinked={"/api/geofences?deviceId=" + item.id}
                            baseId={item.id}
                            keyBase="deviceId"
                            keyLink="geofenceId"
                            label={t('sharedGeofences')}
                            variant="filled"/>
                        <LinkField
                            margin="normal"
                            endpointAll="/api/notifications"
                            endpointLinked={"/api/notifications?deviceId=" + item.id}
                            baseId={item.id}
                            keyBase="deviceId"
                            keyLink="notificationId"
                            titleGetter={it => t(prefixString('event', it.type))}
                            label={t('alerts')}
                            variant="filled"/>
                        <LinkField
                            margin="normal"
                            endpointAll="/api/drivers"
                            endpointLinked={"/api/drivers?deviceId=" + item.id}
                            baseId={item.id}
                            keyBase="deviceId"
                            keyLink="driverId"
                            label={t('sharedDrivers')}
                            variant="filled"/>
                        <LinkField
                            margin="normal"
                            endpointAll="/api/attributes/computed"
                            endpointLinked={"/api/attributes/computed?deviceId=" + item.id}
                            baseId={item.id}
                            keyBase="deviceId"
                            keyLink="attributeId"
                            titleGetter={it => it.description}
                            label={t('sharedComputedAttributes')}
                            variant="filled"/>
                        <LinkField
                            margin="normal"
                            endpointAll="/api/maintenance"
                            endpointLinked={"/api/maintenance?deviceId=" + item.id}
                            baseId={item.id}
                            keyBase="deviceId"
                            keyLink="maintenanceId"
                            label={t('sharedMaintenance')}
                            variant="filled"/>
                    </AccordionDetails>
                </Accordion>
            }
        </ EditItemView>
    );
}

export default DeviceConnections;